/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function DeviceGroupRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.deviceGroups', {
            url: '/deviceGroups',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value,
                types.authority.SUB_CUSTOMER_ADMIN.value, types.authority.SUB_CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'device-group.device-groups'
            },
            ncyBreadcrumb: {
                label: '{"icon": "apps", "label": "device-group.device-groups"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, deviceGroupTableConfig) {
                        return deviceGroupTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.subCustomers.deviceGroups', {
            url: '/:subCustomerId/deviceGroups',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'device-group.device-groups'
            },
            ncyBreadcrumb: {
                label: '{"icon": "apps", "label": "device-group.device-groups"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, deviceGroupTableConfig) {
                        return deviceGroupTableConfig.getConfig($stateParams);
                    }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/device-group/device-group.routes.js